import { useState } from "react";

export default function useTable({
	data,
	columns,
	visibleColumns: initialVisibleColumns,
	defaultVisibleColumns: initialDefaultVisibleColumns,
}) {
	const defaultVisibleColumns =
		initialDefaultVisibleColumns ||
		columns
			.filter((column) => !column?.hidden)
			.map((column) => column?.id)
			.filter(Boolean);

	const [selectedRowIds, setSelectedRowIds] = useState([]);
	const [visibleColumns, setVisibleColumns] = useState(initialVisibleColumns || defaultVisibleColumns);

	const filteredColumns = columns.filter((column) => visibleColumns.includes(column?.id));
	const selectedRows = data.filter(({ id }) => selectedRowIds.includes(id));

	return {
		data,
		columns,
		selectedRows,
		selectedRowIds,
		setSelectedRowIds,
		filteredColumns,
		visibleColumns,
		setVisibleColumns,
		defaultVisibleColumns,
	};
}
